import { Admission } from '@domain/admission';
import { Preset } from '@domain/preset';

export const getAdmissionOnlinePrice = (admission: Admission | Preset) =>
  admission.price.onlinePrice === admission.price.amount ? undefined : admission.price.onlinePrice;
